// @flow

export const template = [[7, 6, 5, 4, 3, 2, 1, 0]]



// WEBPACK FOOTER //
// ./src/shared/components/mandatfordeling/MandatfordelingTable/svg/large-fylke-template.js